export default __webpack_public_path__ + "static/media/MATÉRIEL_SCIENTIFIQUE.874d5ea6.jpg";